module.exports = require("./dir");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-file4/index.js
 ** module id = 9
 ** module chunks = 0
 **/